<template>
	<div class="container">
		<el-tabs v-model="activeName" @tab-click="handleClick" :class="'custom-tabs-' + activeName">
			<el-tab-pane label="号码查询" name="gmQuery">
				<div class="handle-box">
					<el-input size="small" v-model="serNum" clearable maxlength="12" placeholder="号码"
						style="width: 180px;" class="handle-input mr10"></el-input>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
						@click="getGmPhoneInfo">搜索</el-button>
				</div>
				<div class="table-box" v-if="woData">
					<div class="user-info-box">
						<div class="user-info-tit">账户信息</div>
						<div class="info-box">
							<div class="info-name">入网时间：</div>
							<div class="info" style="">{{woData.joinTime}}</div>
						</div>
						<div class="info-box">
							<div class="info-name">号码状态：</div>
							<div class="info" style="" v-if="woData.serviceStatus==0">换卡</div>
							<div class="info" style="" v-if="woData.serviceStatus==1">开机</div>
							<div class="info" style="" v-if="woData.serviceStatus==2">停机</div>
							<div class="info" style="" v-if="woData.serviceStatus==3">半停</div>
							<div class="info" style="" v-if="woData.serviceStatus==4">销户</div>
						</div>
						<div class="info-box">
							<div class="info-name">状态变化：</div>
							<div class="info" style="" v-if="woData.statusChgType==0">新装</div>
							<div class="info" style="" v-if="woData.statusChgType==1">报开(解挂)</div>
							<div class="info" style="" v-if="woData.statusChgType==2">帐务开机(清欠自动开机)</div>
							<div class="info" style="" v-if="woData.statusChgType==3">强开</div>
							<div class="info" style="" v-if="woData.statusChgType==4">帐务欠停(欠费全停)</div>
							<div class="info" style="" v-if="woData.statusChgType==5">强停</div>
							<div class="info" style="" v-if="woData.statusChgType==6">报停(挂失)</div>
							<div class="info" style="" v-if="woData.statusChgType==7">帐务欠半停(欠费半停)</div>
							<div class="info" style="" v-if="woData.statusChgType==8">预约销户</div>
							<div class="info" style="" v-if="woData.statusChgType==9">预约销户撤销</div>
							<div class="info" style="" v-if="woData.statusChgType==10">销户</div>
							<div class="info" style="" v-if="woData.statusChgType==12">强制销户</div>
							<div class="info" style="" v-if="woData.statusChgType==34">停机保号</div>
							<div class="info" style="" v-if="woData.statusChgType==35">复机</div>
							<div class="info" style="" v-if="woData.statusChgType==50">预开</div>
						</div>
						<div class="info-box">
							<div class="info-name">状态变更时间：</div>
							<div class="info" style="" v-if="woData.statusChgTime">{{woData.statusChgTime}}</div>
						</div>
						<div class="info-box">
							<div class="info-name">卡类型：</div>
							<div class="info">{{woData.simType}}</div>


						</div>
						<div class="info-box">
							<div class="info-name">运营商：</div>
							<div class="info" v-if="woData.basicOrgId==0">联通</div>
							<div class="info" v-if="woData.basicOrgId==1">电信</div>
							<div class="info" v-if="woData.basicOrgId==2">移动</div>
						</div>
						<div class="info-box">
							<div class="info-name">归属地：</div>
							<div class="info">{{woData.provinceCode}}-{{woData.cityCode}}</div>

						</div>
					</div>
					<div class="user-info-box">
						<div class="user-info-tit">资费余量</div>
						<div class="info-box">
							<div class="info-name">当月实时话费：</div>
							<div class="info" style="">{{(woData.currentFee/1000).toFixed(2)||0}}元</div>
						</div>
						<div class="info-box">
							<div class="info-name">余额：</div>
							<div class="info" style="">{{(woData.owningFee/1000).toFixed(2)||0}}元</div>
						</div>
						<div class="info-box" v-for="item in woData.resBookBalanceSummarys" :key="item">
							<div class="info-name">{{item.balanceContent}}套餐：</div>
							<div class="info" style="" :key="item.subjectId">
								<span>本月已使用量{{item.usedAmount.toFixed(2)||0}}{{item.resUnitName}}，当前可用余量:{{item.balanceAmount.toFixed(2)||0}}{{item.resUnitName}}</span>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="批量查询" name="gmBatchQuery">
				<div class="handle-box">
					<el-button size="small" type="primary" :class="[theme]"
						@click="getbatchQueryRecord">批量查询</el-button>
					<a :href="`${path}dxtQuery.txt`" class="down" style="margin:10px 10px;" download="批量查询模板.txt"
						:class="[theme]">
						<i class="el-icon-download"></i>
						下载模板
					</a>
					<el-button size="small" type="primary" :class="[theme]" @click="batchQueryRecords">刷新</el-button>
				</div>
				<el-table :data="tableData2" border class="table" ref="multipleTable" max-height="600"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
					v-loading="loading">
					<el-table-column prop="uid" label="处理批次" align="center" width="350"></el-table-column>
					<el-table-column prop="count" label="总数量" align="center"></el-table-column>
					<el-table-column prop="success" label="成功" align="center"></el-table-column>
					<el-table-column prop="err" label="失败" align="center">
						<template #default="scope">
							<span style="color: #f56c6c;">{{ scope.row.err }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="time" label="时间" align="center"></el-table-column>
					<el-table-column prop="userPhone" label="操作者" align="center"></el-table-column>
					<el-table-column label="操作" width="240" align="center">
						<template #default="scope">
							<a :href="scope.row.url" class="down" download="国美用户信息批量查询数据.text" :class="[theme]">
								<i class="el-icon-download"></i>
								下载
							</a>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="query2.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="query2.pageSize" :total="pageTotal2" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
			</el-tab-pane>
			<el-tab-pane label="单个充值" name="gmRecharge">
				<div class="handle-box">
					<el-select size="small" @change="agentChange" v-model="query3.agentId" filterable clearable
						placeholder="请选择代理商" class="handle-select mr10" style="width: 260px;">
						<el-option v-for="item in agents" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" style="width: 260px;" v-model="query3.companyId" filterable clearable
						placeholder="企业" class="handle-select mr10">
						<el-option v-for="item in companys" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-input size="small" v-model="query3.serNum" clearable maxlength="12" placeholder="号码"
						style="width: 180px;" class="handle-input mr10"></el-input>
					<el-input size="small" v-model="query3.uid" clearable placeholder="流水号" class="handle-input mr10"
						style="width: 180px;"></el-input>
					<el-input size="small" v-model="query3.orderId" clearable placeholder="订单编号"
						class="handle-input mr10" style="width: 180px;"></el-input>
					<el-select size="small" style="width: 100px" v-model="query3.orderStatus" filterable clearable
						placeholder="状态" class="handle-select mr10">
						<el-option v-for="item in statusList" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
						@click="getrechargeRecord">搜索</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getAdd">充值</el-button>
					<el-button size="small" type="primary" :class="[theme]"
						@click="getbatchCanceVisible">批量返销</el-button>
				</div>
				<el-table :data="tableData3" border class="table" ref="multipleTable" max-height="600"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
					v-loading="loading">
					<el-table-column prop="agentName" label="代理商" align="center"></el-table-column>
					<el-table-column prop="companyName" label="企业" align="center"></el-table-column>
					<el-table-column prop="serNum" label="号码" align="center" width="120"></el-table-column>
					<el-table-column prop="orderId" label="订单编号" align="center"></el-table-column>
					<el-table-column prop="amount" label="金额(元)" align="center" width="90"></el-table-column>
					<el-table-column prop="orderStatus" label="状态" align="center" width="90">
						<template #default="scope">
							<span v-if="scope.row.orderStatus=='00'">待充值</span>
							<span v-if="scope.row.orderStatus=='01'">充值中</span>
							<span v-if="scope.row.orderStatus=='02'">充值成功 </span>
							<el-tooltip class="item" effect="dark" :content="scope.row.errMsg" placement="top"
								v-if="scope.row.orderStatus=='03'">
								<span style="color: #f56c6c;">充值失败</span>
							</el-tooltip>
							<span v-if="scope.row.orderStatus=='04'" style="color: #f56c6c;">取消</span>
						</template>
					</el-table-column>

					<el-table-column prop="createdAt" label="时间" width="155" align="center"></el-table-column>
					<el-table-column prop="userPhone" label="操作者" align="center" width="100"></el-table-column>
					<el-table-column label="流水号" align="center">
						<template #default="scope">
							<span style="cursor: pointer;">
								<i @click="getdownloadBatchTopUp(scope.row.uid)" class="el-icon-download"
									:class="[theme3]" style="margin-right:10px;font-weight: 600;"></i>
								<span @click="copyUrl(scope.row.uid)">{{ scope.row.uid }}</span>
								<span @click="getCancelRecharge(scope.row)"
									style="margin-left: 10px;color: #ff0000;">返销</span>
							</span>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="query3.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="query3.pageSize" :total="pageTotal3" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
			</el-tab-pane>
			<el-tab-pane label="批量充值" name="gmBatchRecharge">
				<div class="handle-box">
					<el-button size="small" type="primary" :class="[theme]" @click="getaddVisible">批量充值</el-button>
					<a :href="`${path}gmbatchRecharge.xls`" class="down" :class="[theme]" style="margin:10px 10px;"
						download="批量充值模板.xlsx">
						<i class="el-icon-download"></i>
						下载模板
					</a>
					<el-button size="small" type="primary" :class="[theme]" @click="batchTopUpRecords">刷新</el-button>
				</div>
				<el-table :data="tableData4" border class="table" ref="multipleTable" max-height="600"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
					v-loading="loading">
					<el-table-column prop="uid" label="处理批次" align="center" width="350"></el-table-column>
					<el-table-column prop="count" label="总数量" align="center"></el-table-column>
					<el-table-column prop="success" label="成功" align="center"></el-table-column>
					<el-table-column prop="totalSuccess" label="成功金额(元)" align="center"></el-table-column>
					<el-table-column prop="err" label="失败" align="center">
						<template #default="scope">
							<span style="color: #f56c6c;">{{ scope.row.err }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="totalErr" label="失败金额(元)" align="center">
						<template #default="scope">
							<span style="color: #f56c6c;">{{ scope.row.totalErr }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="time" label="时间" align="center" width="180"></el-table-column>
					<el-table-column prop="userPhone" label="操作者" align="center"></el-table-column>
					<el-table-column label="操作" width="240" align="center">
						<template #default="scope">
							<el-button size="small" @click="getdownloadBatchTopUp(scope.row.uid)" type="primary"
								:class="[theme]">下载</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="query4.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="query4.pageSize" :total="pageTotal4" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
			</el-tab-pane>
			<el-tab-pane label="资金池" name="gmCapitalPool">
				<el-row :gutter="20">
					<el-col :span="20">
						<el-row :gutter="20" class="mgb20">
							<el-col :span="8">
								<el-card shadow="hover" :body-style="{ padding: '0px' }">
									<div class="grid-content grid-con-2">
										<i class="el-icon-receiving grid-con-icon"></i>
										<div class="grid-cont-right">
											<div class="grid-num" :class="theme3">{{ capitaltotal || 0 }}</div>
											<div>剩余量</div>
										</div>
									</div>
								</el-card>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="4"><el-button size="small" type="primary" :class="[theme]"
							@click="addCapital">添加金额</el-button></el-col>
				</el-row>
				<div class="container">
					<el-table :data="capitaltableData" border class="table m_t_20" header-cell-class-name="table-header"
						:row-style="{ height: '20px' }" :header-cell-style="{ 'text-align': 'center' }"
						:cell-style="{ padding: '6px' }" stripe v-loading="loading">
						<el-table-column prop="label" label="数量" align="center">
							<template #default="scope">
								<span>{{ scope.row.label }}元</span>
							</template>
						</el-table-column>
						<el-table-column prop="value" label="时间" align="center"></el-table-column>
					</el-table>
				</div>

				<el-dialog title="添加金额" v-model="addCapitalNum" width="450px" @close="closeCapitalNum"
					:close-on-click-modal="false">
					<el-form :model="capitalForm" ref="form" label-width="100px">
						<el-form-item label="添加金额">
							<el-input size="small" style="width: 250px;" placeholder="请输入添加金额"
								v-model="capitalForm.amount"></el-input>
							<span class="m_l_10">元</span>
						</el-form-item>
						<div class="dis-end">
							<el-button size="small" class="btn" @click="closeCapitalNum">取消</el-button>
							<el-button size="small" class="btn" :class="[theme]" style="border: none;" type="success"
								@click="getcapitalPoolAdd">确定</el-button>
						</div>
					</el-form>
				</el-dialog>
			</el-tab-pane>
			<el-tab-pane label="停机" name="gmShutdownList">
				<div class="handle-box">
					<el-select size="small" @change="agentChange" v-model="query6.agentId" filterable clearable
						placeholder="请选择代理商" class="handle-select mr10" style="width: 260px;">
						<el-option v-for="item in agents" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" style="width: 260px;" v-model="query6.companyId" filterable clearable
						placeholder="企业" class="handle-select mr10">
						<el-option v-for="item in companys" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-input size="small" v-model="query6.phone" clearable maxlength="12" placeholder="请输入号码"
						style="width: 180px;" class="handle-input mr10"></el-input>
					<el-select size="small" v-model="query6.operateMsg" filterable clearable placeholder="请选择停机类型"
						class="handle-select mr10">
						<el-option v-for="item in operateMsgList" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" style="width: 100px" v-model="query6.status" filterable clearable
						placeholder="状态" class="handle-select mr10">
						<el-option v-for="item in statusLists" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
						@click="getGmShutdownList">搜索</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getstopVisible">批量停机</el-button>
				</div>
				<el-table :data="tableData6" border class="table" ref="multipleTable" max-height="600"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
					@selection-change="handleSelectionChange" v-loading="loading">
					<el-table-column type="selection" width="55" align="center"></el-table-column>
					<el-table-column prop="agent" label="代理商" align="center" min-width="140"></el-table-column>
					<el-table-column prop="company" label="企业" align="center" min-width="120"></el-table-column>
					<el-table-column prop="phone" label="号码" align="center" width="130"></el-table-column>
					<el-table-column prop="operateMsg" label="停机类型" align="center"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
					<el-table-column prop="status" label="状态" align="center" width="100">
						<template #default="scope">
							<el-tooltip class="item" effect="dark" :content="scope.row.errMsg" placement="top"
								v-if="scope.row.status=='失败'">
								<span style="color: #f56c6c;">失败</span>
							</el-tooltip>
							<span v-else>{{scope.row.status}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="createdAt" label="时间" width="180" align="center"></el-table-column>
					<el-table-column prop="userPhone" label="操作员" align="center"></el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="query6.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="query6.pageSize" :total="pageTotal6" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
				<el-dialog title="批量停机" v-model="stopVisible" width="520px" @close="closeDialog">
					<el-form label-width="120px" :model="stopForm" ref="stopForm">
						<el-form-item label="选择模式" prop="type">
							<el-radio-group v-model="stopForm.type">
								<el-radio label="2">手动输入</el-radio>
								<el-radio label="1">批量停开机模板</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="手机号码" prop="phones" v-if="stopForm.type == '2'">
							<el-input size="small" :rows="5" type="textarea" v-model="stopForm.phones"
								auto-complete="off" placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
						</el-form-item>
						<el-form-item label="上传文件" prop="" v-else>
							<el-upload ref="stopUpload" action="/api/gome/stopPhone" :headers="token" :limit="1"
								:on-success="uploadStopSuccess" :auto-upload="false" :data="stopForm">
								<el-button size="small" type="primary" :class="[theme]"
									style="margin-top: 40px;">选择文件</el-button>
								<div class="el-upload__tip">只能导入txt文件</div>
							</el-upload>
						</el-form-item>
						<el-form-item label="停机类型" prop="operateMsg">

							<el-radio-group v-model="stopForm.operateMsg">
								<el-radio v-for="item in operateMsgList" :key="item" :label="item.value"
									style="margin: 4px;font-size: 16px;" :value="item.value">{{item.label}}</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="备注" prop="remark">
							<el-input size="small" :rows="5" type="textarea" v-model="stopForm.remark"
								auto-complete="off" placeholder="请输入停机备注"></el-input>
						</el-form-item>
						<el-form-item class="dis-end">
							<el-button size="small" @click="closeDialog">取消</el-button>
							<el-button size="small" type="primary" :class="[theme]" v-if="stopForm.type == '2'"
								@click="batchStop">确定</el-button>
							<el-button size="small" type="primary" :class="[theme]" v-else
								@click="submitStopUpload">确定</el-button>
						</el-form-item>
					</el-form>
				</el-dialog>

			</el-tab-pane>
			<el-tab-pane label="异常话单" name="gmAbnormalCallListNew">
				<div class="handle-box">
					<el-select size="small" @change="agentChange" v-if="isAdmin" v-model="query7.agentId" filterable
						clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
						<el-option v-for="item in agents" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" v-if="isSubAgent" v-model="query7.subAgentId"
						@change="getfetchDefaultCompanies" filterable clearable placeholder="子代理"
						class="handle-select mr10" style="width: 260px">
						<el-option v-for="item in subAgentList" :key="item.id" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
					<el-select size="small" style="width: 260px" v-model="query7.companyId" @change="companyChange"
						filterable clearable placeholder="企业" class="handle-select mr10">
						<el-option v-for="item in companys" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-input size="small" v-model="query7.phone" clearable maxlength="12" placeholder="号码"
						style="width: 180px;" class="handle-input mr10"></el-input>
					<el-date-picker size="small" v-model="timeArr" type="daterange" unlink-panels range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_l_10"
						@click="getgmErrRecord">搜索</el-button>
				</div>
				<el-table :data="tableData7" border class="table" ref="multipleTable" max-height="600"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
					v-loading="loading">
					<el-table-column prop="agentName" label="代理商" align="center"></el-table-column>
					<el-table-column prop="companyName" label="企业名称" align="center"></el-table-column>
					<el-table-column prop="phone" label="手机号" align="center"></el-table-column>
					<el-table-column prop="phoneNumber" label="被叫号码" align="center"></el-table-column>
					<el-table-column prop="time" label="时间" align="center"></el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="query7.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="query7.pageSize" :total="pageTotal7" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>

			</el-tab-pane>
		</el-tabs>
		<el-dialog title="批量查询" v-model="gmBatchVisible" width="520px" @close="closegmBatchDialog">
			<el-form label-width="120px" :model="gmBatchForm" ref="gmBatchForm">
				<el-form-item label="上传类型" prop="type">
					<el-radio-group v-model="gmBatchForm.type">
						<el-radio label="2">手动输入</el-radio>
						<el-radio label="1">批量查询模板</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="上传文件" v-if="gmBatchForm.type=='1'">
					<el-upload ref="upload" action="/api/gome/batchQuery" :headers="token" :limit="1"
						:on-success="uploadSuccess" :auto-upload="false" :data="uploadData">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top: 40px;">选择文件</el-button>
						<div class="el-upload__tip">只能导入txt文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="批量查询" v-if="gmBatchForm.type=='2'">
					<el-input size="small" :rows="5" type="textarea" v-model="gmBatchForm.phones" auto-complete="off"
						placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closegmBatchDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="gmBatchForm.type == '2'"
						@click="getgmBatchQuery">确定</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-else
						@click="submitgmBatchQueryUpload">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>


		<el-dialog title="批量充值" v-model="batchRechargeVisible" width="520px" @close="closebatchRechargeDialog">
			<el-form label-width="120px" :model="batchRechargeForm" ref="batchRechargeForm">
				<el-form-item label="上传文件" prop="">
					<el-upload ref="batchRechargeupload" action="/api/gome/batchTopUp" :headers="token" :limit="1"
						:on-success="uploadbatchRechargeSuccess" :auto-upload="false" :data="uploadbatchRechargeData">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top: 40px;">选择文件</el-button>
						<div class="el-upload__tip">只能导入xls文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closebatchRechargeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]"
						@click="submitbatchRechargeUpload">确定</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>
		<el-dialog title="充值" v-model="singleVisible" width="450px" @close="closesingleDialog">
			<el-form label-width="120px" :model="singleForm" ref="singleForm">
				<el-form-item label="手机号">
					<el-input size="small" style="width: 250px;" placeholder="请输入手机号"
						v-model="singleForm.serNum"></el-input>
				</el-form-item>
				<el-form-item label="添加金额">
					<el-input v-model="singleForm.fee" size="small" style="width: 250px;" placeholder="请输入金额"
						οninput="value=value.replace(/[^0-9]/g,'')" />
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closesingleDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="prepayAdd">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog title="批量返销" v-model="batchCanceVisible" width="450px" @close="closebatchDialog">
			<el-form label-width="120px" :model="batchCanceForm" ref="batchCanceForm">
				<el-form-item label="流水号:" prop="uid">
					<el-input size="small" v-model="batchCanceForm.uid" clearable placeholder="流水号"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closebatchDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]"
						@click="getBatchCancelRecharge">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>



	</div>
</template>

<script>
	import {
		fetchDepartment
	} from '../api/index';
	import {
		fetchAgent,
	} from '../api/agentIndex';
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../api/companyIndex';
	import {
		GmPhoneInfo,
		batchQueryRecord,
		batchQuery,
		fundPoolAdd,
		fundPool,
		rechargeRecord,
		batchTopUpRecord,
		cancelRecharge,
		prepayAdd,
		downloadBatchTopUp,
		batchTopUp,
		stopRecord,
		stopPhone,
		gmErrRecord
	} from '../api/gm.js';
	export default {
		name: 'GMvirtualCommerce',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query1: {
					pageIndex: 1,
					pageSize: 10,
				},
				woData: '',
				serNum: '',

				query2: {
					pageIndex: 1,
					pageSize: 10,
					userId: localStorage.getItem('user'),
				},
				gmBatchVisible: false,
				gmBatchForm: {
					userId: localStorage.getItem('user'),
					phones: '',
					type: "2",
				},
				uploadData: {
					userId: localStorage.getItem('user'),
					type: '1',
				},

				query3: {
					agentId: '',
					companyId: '',
					userId: localStorage.getItem('user'),
					serNum: '',
					uid: '',
					orderStatus: '',
					pageIndex: 1,
					pageSize: 10,
				},
				statusList: [{
						value: '00',
						label: '待充值'
					},
					{
						value: '01',
						label: '充值中'
					},
					{
						value: '02',
						label: '充值成功'
					},
					{
						value: '03',
						label: '充值失败'
					},
					{
						value: '04',
						label: '取消'
					},
				],
				singleVisible: false,
				singleForm: {
					userId: localStorage.getItem('user'),
					serNum: '',
					fee: '',
				},
				batchquery: {
					pageIndex: 1,
					pageSize: 10,
					userId: localStorage.getItem('user'),
				},
				dxtDet: '',

				capitaltableData: [],
				capitaltotal: '',
				batchCanceForm: {
					uid: '',
				},
				batchCanceVisible: false,

				query4: {
					pageIndex: 1,
					pageSize: 10,
					userId: localStorage.getItem('user'),
				},
				batchRechargeVisible: false,
				uploadbatchRechargeData: {
					userId: localStorage.getItem('user'),
				},

				query5: {
					pageIndex: 1,
					pageSize: 10,
				},
				addCapitalNum: false,
				capitalForm: {
					amount: '',
				},

				query6: {
					agentId: '',
					companyId: '',
					phone: '',
					operateMsg: '',
					status: '',
					pageIndex: 1,
					pageSize: 10,
					userId: localStorage.getItem('user'),
				},
				operateMsgList: [{
						value: 'Q01',
						label: 'Q01-代理商管控关停，实名补登记复机'
					},
					{
						value: 'Q02',
						label: 'Q02-代理商管控关停，二次实人认证复机'
					},
					{
						value: 'Q03',
						label: 'Q03-代理商管控关停，强停不予复机'
					},
					{
						value: 'Q04',
						label: 'Q03-外部平台脱离APP管控停机'
					},
				],
				statusLists: [{
						value: null,
						label: '全部'
					},
					{
						value: '0',
						label: '成功'
					},
					{
						value: '-1',
						label: '失败'
					},
				],
				stopForm: {
					userId: localStorage.getItem('user'),
					type: '2',
					phones: '',
					operateMsg: 'Q01',
					remark: '',
				},
				uploadstopData: {
					userId: localStorage.getItem('user'),
				},
				stopVisible: false,

				query7: {
					companyId: '',
					userId: localStorage.getItem('user'),
					phone: '',
					pageIndex: 1,
					pageSize: 10,
					subAgentId: '',
				},

				timeArr: [],
				tableData1: [],
				tableData2: [],
				tableData3: [],
				tableData4: [],
				tableData5: [],
				tableData6: [],
				tableData7: [],
				multipleSelection: [],
				pageTotal1: 0,
				pageTotal2: 0,
				pageTotal3: 0,
				pageTotal4: 0,
				pageTotal5: 0,
				pageTotal6: 0,
				pageTotal7: 0,
				path: process.env.BASE_URL,
				token: {
					Authorization: localStorage.getItem('token'),
					type: 'web',
					UserRole: localStorage.getItem('ms_role'),
					XSecurityVersion: 'v2',
				},
				upload: false,
				isAdmin: false,
				isAgent: false,
				isCompany: false,
				isNormal: false,
				isSubAgent: false,
				activeName: 'gmQuery',
				agents: [],
				companys: [],
				departments: [],
			};
		},
		created() {
			let role = localStorage.getItem('ms_role');
			if (role === 'admin') {
				this.isAdmin = true;
			}
			if (role === 'agent') {
				this.isAgent = true;
			}
			if (role === 'normal') {
				this.isNormal = true;
			}
			if (role === 'company') {
				this.isCompany = true;
			}
			this.updateTabStyle();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle(){
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.number:hover {
				        color: ${this.theme8} !important;
				    }
					.active:hover {
					    color: #fff !important;
					}
					.more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			updateTabStyle() {
				// 动态更新样式
				let styleEl = document.getElementById('dynamic-tab-style');
				if (!styleEl) {
					styleEl = document.createElement('style');
					styleEl.id = 'dynamic-tab-style';
					document.head.appendChild(styleEl);
				}

				styleEl.innerHTML = `
			        .el-tabs__active-bar {
			            background-color: ${this.theme8} !important;
			        }
			        .el-tabs__item.is-active {
			            color: ${this.theme8} !important;
			        }
			        .el-tabs__item:hover {
			            color: ${this.theme8} !important;
			            opacity: 0.8;
			        }
			    `;
			},
			handleClick(tab, event) {
				this.activeName = tab.props.name;
				if (tab.props.name == 'gmQuery') {
					if (this.serNum) {
						this.getGmPhoneInfo();
					}
				} else if (tab.props.name == 'gmBatchQuery') {
					this.batchQueryRecords();
				} else if (tab.props.name == 'gmRecharge') {
					this.query3.agentId = '';
					this.query3.companyId = '';
					this.init();
					this.getrechargeRecord();
				} else if (tab.props.name == 'gmBatchRecharge') {
					this.batchTopUpRecords();
				} else if (tab.props.name == 'gmCapitalPool') {
					this.getfundPool();
				} else if (tab.props.name == 'gmShutdownList') {
					this.query6.agentId = '';
					this.query6.companyId = '';
					this.init();
					this.getGmShutdownList();
				} else if (tab.props.name == 'gmAbnormalCallListNew') {
					this.query7.agentId = '';
					this.query7.companyId = '';
					this.init();
					this.timeArr = [];
					this.getTime();
					this.getgmErrRecord();
				}
			},
			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;

			},
			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				this.getfetchDefaultCompanies();
			},
			getfetchDefaultCompanies() {
				this.query3.companyId = '';
				this.query6.companyId = '';
				this.query7.companyId = '';
				let data = {
					currentUserId: localStorage.getItem('user'),
					subAgentId: ''
				};
				fetchDefaultCompanies(data).then(res => {
					if (res?.code === 200) {
						this.companys = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			agentChange(agentId) {
				this.query3.agentId = agentId;
				this.query3.companyId = '';
				this.query6.agentId = agentId;
				this.query6.companyId = '';
				this.query7.agentId = agentId;
				this.query7.companyId = '';
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				}
			},
			companyChange(companyId) {
				this.query3.companyId = companyId;
				this.query6.companyId = companyId;
				this.query7.companyId = companyId;
				let data = {
					companyId: companyId,
					currentUserId: localStorage.getItem('user')
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;

				});
			},
			toDateTimeStr(date) {
				let y = date.getFullYear();
				let m = date.getMonth() + 1;
				let d = date.getDate();
				if (m < 10) {
					m = '0' + m;
				}
				if (d < 10) {
					d = '0' + d;
				}
				return y + '-' + m + '-' + d;
			},
			//筛选时间
			getTime() {
				//时间
				let startTime = new Date(new Date());
				let endTime = new Date();
				this.timeArr.push(startTime);
				this.timeArr.push(endTime);
			},
			getGmPhoneInfo() {
				this.woData = '';
				GmPhoneInfo(this.serNum.trim()).then(res => {
					if (res?.code === 200) {
						this.woData = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			batchQueryRecords() {
				this.loading = true;
				batchQueryRecord(this.query2).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData2 = res.data.list;
						this.pageTotal2 = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getgmBatchQuery() {
				this.loading = true;
				batchQuery(this.gmBatchForm).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.$message.success(res.data);
						this.gmBatchVisible = false;
						this.batchQueryRecords();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			submitgmBatchQueryUpload() {
				if (this.$refs.upload.uploadFiles[0]) {
					this.loading = true;
					this.$refs.upload.submit();
					this.batchQueryRecords();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			//导入上传
			uploadSuccess(success) {
				setTimeout(() => {
					this.$refs.upload.clearFiles();
					this.gmBatchVisible = false;
				}, 2000);
				if (success?.code === 200) {
					this.$message.success('上传成功');
					this.batchQueryRecords();
				} else {
					this.$message.error(success.message);
				}
			},
			getbatchQueryRecord() {
				this.gmBatchVisible = true;
				this.gmBatchForm.type = '2';
				this.gmBatchForm.phones = '';
			},
			closegmBatchDialog() {
				this.gmBatchVisible = false;
			},
			getrechargeRecord() {
				this.loading = true;
				rechargeRecord(this.query3).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData3 = res.data.list;
						this.pageTotal3 = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			copyUrl(item) {
				let cInput = document.createElement('input');
				cInput.value = item;
				document.body.appendChild(cInput);
				cInput.select();
				document.execCommand('copy');
				this.$message.success('复制成功');
				document.body.removeChild(cInput);
			},
			batchTopUpRecords() {
				this.loading = true;
				batchTopUpRecord(this.query4).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData4 = res.data.list;
						this.pageTotal4 = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			submitUpload() {
				if (this.$refs.upload.uploadFiles[0]) {
					this.$refs.upload.submit();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			closebatchDialog() {
				this.batchCanceVisible = false;
			},
			getbatchCanceVisible() {
				this.batchCanceVisible = true;
				this.batchCanceForm.uid = '';
			},
			getBatchCancelRecharge() {
				this.$confirm('确定要返销该批次数据吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						let data = {
							userId: localStorage.getItem('user'),
							uid: this.batchCanceForm.uid,
							type: 2,
						};
						cancelRecharge(data).then(res => {
							if (res?.code === 200) {
								this.getrechargeRecord();
							} else {
								this.getrechargeRecord();
								this.$message.error(res.message);
							}
						});
					})
					.catch(() => {});
			},
			getCancelRecharge(row) {
				this.$confirm('确定要返销该批次数据吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						let data = {
							userId: localStorage.getItem('user'),
							type: 1,
							orderId: row.orderId
						};
						cancelRecharge(data).then(res => {
							if (res?.code === 200) {
								this.getrechargeRecord();
							} else {
								this.getrechargeRecord();
								this.$message.error(res.message);
							}
						});
					})
					.catch(() => {});
			},
			getdownloadBatchTopUp(uid) {
				this.$confirm('确定要下载该批次数据吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						let data = {
							uid: uid
						};
						downloadBatchTopUp(data).then(res => {
							const blob = new Blob([res], {
								type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
							});
							let downloadElement = document.createElement('a');
							let href = window.URL.createObjectURL(blob);
							downloadElement.href = href;
							let fileName = '国美批量充值' + '.xls';
							downloadElement.download = fileName;
							document.body.appendChild(downloadElement);
							downloadElement.click();
							document.body.removeChild(downloadElement);
							window.URL.revokeObjectURL(href);
						});
					})
					.catch(() => {});
			},
			//导入上传
			uploadbatchRechargeSuccess(success) {
				setTimeout(() => {
					this.$refs.batchRechargeupload.clearFiles();
					this.batchRechargeVisible = false;
				}, 2000);
				if (success?.code === 200) {
					this.$message.success('上传成功');
					this.batchTopUpRecords();
				} else {
					this.$message.error(success.message);
				}
			},
			submitbatchRechargeUpload() {
				if (this.$refs.batchRechargeupload.uploadFiles[0]) {
					this.$refs.batchRechargeupload.submit();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			getaddVisible() {
				this.batchRechargeVisible = true;
			},
			closebatchRechargeDialog() {
				this.batchRechargeVisible = false;
			},
			getAdd() {
				this.singleVisible = true;
			},

			closesingleDialog() {
				this.singleForm.serNum = '';
				this.singleForm.fee = '';
				this.singleVisible = false;
			},
			prepayAdd() {
				let data = {
					serNum: this.singleForm.serNum,
					fee: this.singleForm.fee,
					userId: localStorage.getItem('user')
				};
				prepayAdd(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.data);
						setTimeout(() => {
							this.singleVisible = false;
							this.getrechargeRecord();
						}, 1000);
					} else {
						this.$message.error(res.message);
					}
				});
			},
			addCapital() {
				this.addCapitalNum = true;
				this.capitalForm.amount = '';
			},
			closeCapitalNum() {
				this.addCapitalNum = false;
				this.capitalForm.amount = '';
			},
			getcapitalPoolAdd() {
				let data = {
					amount: this.capitalForm.amount,
					userId: localStorage.getItem('user')
				};
				fundPoolAdd(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.data);
						this.addCapitalNum = false;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getfundPool() {
				let data = {
					userId: localStorage.getItem('user')
				};
				fundPool(data).then(res => {
					if (res?.code === 200) {
						this.capitaltableData = res.data.selectorList;
						this.capitaltotal = Number(res.data.total.toFixed(2));
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getGmShutdownList() {
				this.loading = true;
				stopRecord(this.query6).then(res => {
					this.loading = false;
					this.tableData6 = res.data.list;
					this.pageTotal6 = res.data.total;
				});
			},
			submitStopUpload() {
				if (this.$refs.stopUpload.uploadFiles[0]) {
					this.$refs.stopUpload.submit();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			//导入上传
			uploadStopSuccess(success) {
				setTimeout(() => {
					this.$refs.stopUpload.clearFiles();
					this.stopVisible = false;
				}, 2000);
				if (success?.code === 200) {
					this.$message.success('上传成功');
					setTimeout(() => {
						this.getGmShutdownList();
					}, 2000);
				} else {
					this.$message.error(success.message);
				}
			},
			getstopVisible() {
				this.stopVisible = true;
				this.stopForm.type = '2';
				this.stopForm.phones = '';
				this.stopForm.operateMsg = 'Q01';
				this.stopForm.remark = '';
			},
			closeDialog() {
				this.stopVisible = false;
			},
			//批量停机 =》手动输入
			batchStop() {
				stopPhone(this.stopForm).then(res => {
					if (res?.code === 200) {
						setTimeout(() => {
							this.stopVisible = false;
							this.getGmShutdownList();
						}, 2000);
						this.$message.success(res.message);
					} else {
						this.$message.error(res.message);
					}
				});
			},



			getgmErrRecord() {
				this.loading = true;
				this.tableData7 = [];
				// 日期
				if (this.timeArr === null) {
					// this.$message.error('时间不能为空');
					// return;
					this.query7.startTime = '';
					this.query7.endTime = '';
				} else {
					let startTime = this.toDateTimeStr(this.timeArr[0]);
					let endTime = this.toDateTimeStr(this.timeArr[1]);
					this.query7.startTime = startTime;
					this.query7.endTime = endTime;
				}
				gmErrRecord(this.query7).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData7 = res.data.list;
						this.pageTotal7 = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			// 分页导航
			handlePageChange(val) {
				if (this.activeName == 'gmQuery') {
					if (this.serNum) {
						this.query1.pageIndex = val;
						this.getGmPhoneInfo();
					}
				} else if (this.activeName == 'gmBatchQuery') {
					this.query2.pageIndex = val;
					this.batchQueryRecords();
				} else if (this.activeName == 'gmRecharge') {
					this.query3.pageIndex = val;
					this.getrechargeRecord();
				} else if (this.activeName == 'gmBatchRecharge') {
					this.query4.pageIndex = val;
					this.batchTopUpRecords();
				} else if (this.activeName == 'gmCapitalPool') {
					this.query5.pageIndex = val;
					this.getfundPool();
				} else if (this.activeName == 'gmShutdownList') {
					this.query6.pageIndex = val;
					this.getGmShutdownList();
				} else if (this.activeName == 'gmAbnormalCallListNew') {
					this.query7.pageIndex = val;
					this.getgmErrRecord();
				}
			},
			handleSizeChange(val) {
				if (this.activeName == 'gmQuery') {
					if (this.serNum) {
						this.query1.pageSize = val;
						this.query1.pageIndex = 1; // 重置到第一页
						this.getGmPhoneInfo();
					}
				} else if (this.activeName == 'gmBatchQuery') {
					this.query2.pageSize = val;
					this.query2.pageIndex = 1; // 重置到第一页
					this.batchQueryRecords();
				} else if (this.activeName == 'gmRecharge') {
					this.query3.pageSize = val;
					this.query3.pageIndex = 1; // 重置到第一页
					this.getrechargeRecord();
				} else if (this.activeName == 'gmBatchRecharge') {
					this.query4.pageSize = val;
					this.query4.pageIndex = 1; // 重置到第一页
					this.batchTopUpRecords();
				} else if (this.activeName == 'gmCapitalPool') {
					this.query5.pageSize = val;
					this.query5.pageIndex = 1; // 重置到第一页
					this.getfundPool();
				} else if (this.activeName == 'gmShutdownList') {
					this.query6.pageSize = val;
					this.query6.pageIndex = 1; // 重置到第一页
					this.getGmShutdownList();
				} else if (this.activeName == 'gmAbnormalCallListNew') {
					this.query7.pageSize = val;
					this.query7.pageIndex = 1; // 重置到第一页
					this.getgmErrRecord();
				}
			},

		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.table-box {
		/* width: 1700px; */
		/* border: 1px solid #ebeef5; */
		display: flex;
		flex-direction: row;
		margin-bottom: 40px;

		.user-info-box {
			/* border: 1px solid #ebeef5; */

			width: 50%;
		}

		.user-info-tit {
			background: #fafafa;
			color: #000;
			font-weight: 600;
			text-align: center;
			line-height: 34px;
			border-right: 1px solid #ebeef5;
			border-bottom: 1px solid #ebeef5;
		}

		.info-box {
			display: flex;
			flex-direction: row;
			line-height: 34px;
			border-bottom: 1px solid #ebeef5;
			border-right: 1px solid #ebeef5;
		}

		.info-name {
			background: #fafafa;
			border-right: 1px solid #ebeef5;
			border-left: 1px solid #ebeef5;
			width: 30%;
			padding-left: 10px;
			font-weight: 600;
		}

		.user-info-box .info-box .info {
			padding-left: 10px;
			color: #226003;
			width: 80%;
			max-width: 80%;
			overflow-wrap: break-word;
			/* 允许单词内换行 */
			word-break: break-word;
			/* 更兼容的断词方式 */
			white-space: normal;
			/* 确保默认换行行为 */

		}
	}


	.down {
		border: 1px solid #dcdfe6;
		background: #4f7afd;
		color: #ffffff;
		transition: 0.1s;
		font-weight: 500;
		padding: 6px 12px;
		font-size: 12px;
		border-radius: 4px;
		display: inline-block;
	}


	.grid-content {
		display: flex;
		align-items: center;
		height: 100px;
	}

	/deep/ .el-col-16 {
		flex: 0 0 59.9%;
	}

	.grid-cont-right {
		flex: 1;
		text-align: center;
		font-size: 20px;
		font-weight: bold;
		color: #999;
	}

	.grid-num {
		font-size: 30px;
		font-weight: bold;
	}

	.grid-con-icon {
		font-size: 50px;
		width: 100px;
		height: 100px;
		text-align: center;
		line-height: 100px;
		color: #fff;
	}

	.grid-con-1 .grid-con-icon {
		background: linear-gradient(#ffb199, #ff0844);
	}

	.new {
		color: #b5b4b4;
		font-size: 12px;
	}

	.grid-con-1 .grid-num {
		color: #4f7afd;
	}

	.grid-con-2 .grid-con-icon {
		background: linear-gradient(#48c6ef, #6f86d6);
	}

	.grid-con-2 .grid-num {
		color: #4f7afd;
	}

	.grid-con-3 .grid-con-icon {
		background: linear-gradient(#e5b2ca, #7028e4);
	}

	.grid-con-3 .grid-num {
		color: #4f7afd;
	}

	.grid-con-4 .grid-con-icon {
		background: linear-gradient(#00c6fb, #005bea);
	}

	.grid-con-4 .grid-num {
		color: #4f7afd;
	}

	.grid-con-5 .grid-con-icon {
		background: linear-gradient(#89f7fe, #66a6ff);
	}

	.grid-con-5 .grid-num {
		color: #4f7afd;
	}
</style>